import { get, isNaN, isFinite } from "lodash"
import { createSelector } from "reselect"
import { STATUSES } from "modules/platform/constants"
import { getIsOpPro } from "modules/account-root/selectors"

const EMPTY_OBJECT = {}
const { ACTIVE } = STATUSES

const getRawAlphaTheoryMetadata = state => get(state, "global.data.alphaTheoryMetadata.data")
export const getAlphaTheoryFunds = state => get(state, "modules.alphaTheory.funds")
export const getImporting = state => get(state, "modules.alphaTheory.importing")

export const getAlphaTheoryStatus = createSelector(
  [getRawAlphaTheoryMetadata],
  (status) => get(status, "status"),
)

export const getAlphaTheoryConnected = createSelector(
  [getAlphaTheoryStatus],
  (status) => status === ACTIVE,
)

export const getResourceLimits = createSelector(
  [getRawAlphaTheoryMetadata, getIsOpPro],
  (status, isOpPro) => {
    if (!isOpPro) { return undefined }
    const { current, limit } = get(status, "resources", EMPTY_OBJECT)
    return {
      current: isFinite(current) ? current : 0,
      limit: isFinite(limit) ? limit : 0,
      available: isNaN(limit - current) ? 0 : limit - current,
    }
  },
)
